<template>
  <div class="mt-0 elegant-container">
    <v-layout wrap>
      <v-flex>
        <section>
          <div class="customer-page">
            <!-- Animated Background -->
            <div class="animated-bg">
              <div class="bg-shape shape-1"></div>
              <div class="bg-shape shape-2"></div>
              <div class="bg-shape shape-3"></div>
            </div>
            <v-dialog v-model="dialog.status"
              @keydown.esc="dialog.status = false"
              :fullscreen="dialog.fullscreen"
              width="700"
              persistent
              scrollable>
              <v-card 
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius-card'"
        class="pa-8 pt-6">
        <v-card-title 
          class="d-flex align-center pa-0 pb-4 text-right popup-header fs-20 font-weight-bold">
          
          Mengubah Status

          <v-spacer/>

          <!-- <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            color="#718EBF">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.status = false; dialog.fullscreen = false; selected.status = [];"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon> -->

          <v-icon 
            @click="dialog.status = false; dialog.fullscreen = false; message.status = ''; message.error = ''"
            class="cursor-pointer"
            size="18"
            color="#000000">
            mdi-close
          </v-icon>
        </v-card-title>
        
        <!-- <v-divider 
          class="mb-2"
          style="border-top: 2px dashed #e0e0e0;"/> -->

        <v-card-text 
          class="body-1 font-weight-light text-first line-text-second my-0 px-0 py-3">
          Apakah Anda yakin mengubah status data menjadi {{ status }} ?

          <!-- <v-autocomplete
            v-if="detail.status === 'pengiriman' || detail.status === 'Set Order'"
            v-model="status"
            :items="['pengiriman','diterima customer']"
            
            label="Pilih Status"
            
            dense
            outlined
            hide-details
            style="width: 100%"
            class="mt-4"
            >
          </v-autocomplete> -->

          <div v-if="detail.status === 'pengiriman' && form.bpb_arr.length > 0">
            <v-card flat style="border-radius: 25px; border: 1px solid #E7E7E7;" class="pb-7 mt-6 mb-5"  v-for="(items, indexs) in form.bpb_arr" :key="indexs">
              <v-card-text>
                <div class="fs-18 input-label mb-8 font-weight-bold pt-2">
                  BPB Ke-{{ indexs+1 }}
                </div>
              <div v-for="(item, index) in items.bpb_detail" :key="index">
                <!-- {{ index+items.bpb_id }} -->
                <!-- <table width="100%" style="border-bottom: thin solid #E6EFF5;">
                  <thead>
                    <tr>
                      <th class="text-left fs-14 font-weight-bold pa-2" style="border-top: thin solid #E6EFF5; border-bottom: thin solid #E6EFF5">Nama Barang</th>
                      <th class="text-left fs-14 font-weight-bold pa-2" style="border-top: thin solid #E6EFF5; border-bottom: thin solid #E6EFF5">No. SKU</th>
                      <th class="text-left fs-14 font-weight-bold pa-2" style="border-top: thin solid #E6EFF5; border-bottom: thin solid #E6EFF5">Qty</th>
                      <th class="text-left fs-14 font-weight-bold pa-2" style="border-top: thin solid #E6EFF5; border-bottom: thin solid #E6EFF5">Qty Lusin</th>
                      <th class="text-left fs-14 font-weight-bold pa-2" style="border-top: thin solid #E6EFF5; border-bottom: thin solid #E6EFF5">Qty Dus</th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="(item, index) in form.varian_arr" :key="index">
                      <td class="text-left label-input fs-16 font-weight-bold pa-2">{{ item.detail_varian_name }}</td>
                      <td class="text-left label-input fs-16 font-weight-bold pa-2">{{ item.detail_varian_sku }}</td>
                      <td class="text-left label-input fs-16 font-weight-bold pa-2">{{ item.detail_qty_pcs_approved }}</td>
                      <td class="text-left label-input fs-16 font-weight-bold pa-2">{{ item.detail_qty_lusin_approved }}</td>
                      <td class="text-left label-input fs-16 font-weight-bold pa-2">{{ item.detail_qty_dus_approved }}</td>
                    </tr>
                  </tbody>
                </table> -->
                <v-card flat class="mb-5" style="background: #718ebf17; border-radius: 15px;">
                  <v-card-text>
                    <div class="fs-16 font-weight-bold label-input">
                      {{ item.varian_name }}
                    </div>
                    <div>
                      <span>Kode SKU</span>: <span>{{ item.varian_sku }}</span>
                    </div>
                    <!-- <div>
                      <span>Harga</span>: <span>{{ item.price | price }}</span>
                    </div> -->

                    <v-row class="pt-3 pb-0">
                      <v-col class="py-0" cols="2">
                        <div 
                          class="fs-15 label-input">
                          Qty yang dikirim
                        </div>
                      </v-col>
                      <v-col class="py-0">
                        <div 
                          class="fs-15 label-input">
                          Qty yang diterima
                        </div>
                      </v-col>
                      <v-col class="py-0">
                        <div 
                          class="fs-15 label-input">
                          Qty yang dikembalikan
                        </div>
                      </v-col>
                    </v-row>

                    <v-row>
                      <v-col class="py-0" cols="2">
              
                        <div class="fs-19 font-weight-bold label-input mt-3">
                          {{ item.qty_pcs }} Pcs
                        </div>
                      </v-col>
                      <!-- <v-col>
                        <div class="fs-15 label-input">
                          Harga
                        </div>

                        <div class="fs-19 font-weight-bold label-input mt-3">
                          {{ item.price | price }}
                        </div>
                      </v-col> -->

                      <v-col class="py-0">
  
                        <v-currency-field
                          
                          filled
                          rounded
                          dense
                          solo
    
                          color="#718EBF"
                          placeholder="Qty"
                          suffix="pcs"

                          
    
                          v-model="item.qty_pcs_diterima"
                          required
                          style="border-radius: 10px;">
                        </v-currency-field>
                        <!-- <div class="fs-15 label-input">
                          Qty
                        </div>

                        <v-currency-field
                          
                          filled
                          rounded
                          dense
                          solo
    
                          color="#718EBF"
                          placeholder="Qty"

                          
    
                          v-model="item.qty"
                          required
                          style="border-radius: 10px;">
                        </v-currency-field> -->
                      </v-col>
                      <v-col class="py-0">
  
                        <v-currency-field
                          
                          filled
                          rounded
                          dense
                          solo
    
                          color="#718EBF"
                          placeholder="Qty"
                          suffix="pcs"

                          
    
                          v-model="item.qty_pcs_return"
                          required
                          style="border-radius: 10px;">
                        </v-currency-field>
                        <!-- <div class="fs-15 label-input">
                          Qty
                        </div>

                        <v-currency-field
                          
                          filled
                          rounded
                          dense
                          solo
    
                          color="#718EBF"
                          placeholder="Qty"

                          
    
                          v-model="item.qty"
                          required
                          style="border-radius: 10px;">
                        </v-currency-field> -->
                      </v-col>
                      <!-- <v-col class="py-0" cols="3">
                        <ValidationProvider
                          :name="`Qty Pcs ${item.varian_name}`"
                          :rules="`required|max_value:${item.qty_pcs_approve}|min_value:0`" 
                          v-slot="{ errors }">
    
                          <v-currency-field
                          
                            filled
                            rounded
                            dense
                            solo
      
                            color="#718EBF"
                            placeholder="Qty"
                            suffix="pcs"
      
                            :value="item.qty_pcs"
                            :error-messages="errors"
                            required
                            style="border-radius: 10px;">
                          </v-currency-field>
                        </ValidationProvider>
                      </v-col> -->

                      <!-- <v-col>
                        <div class="fs-15 label-input">
                          Harga Beli
                        </div>

                        <v-currency-field
                          
                          filled
                          rounded
                          dense
                          solo
    
                          color="#718EBF"
                          placeholder="Harga Beli"
                          
    
                          v-model="item.harga_beli"
                          required
                          style="border-radius: 10px;">
                        </v-currency-field>
                      </v-col>

                      <v-col>
                        <div class="fs-15 label-input">
                          PPN Beli
                        </div>

                        <v-currency-field
                          
                          filled
                          rounded
                          dense
                          solo
    
                          color="#718EBF"
                          placeholder="PPN Beli"
                          
    
                          v-model="item.ppn_beli"
                          required
                          style="border-radius: 10px;">
                        </v-currency-field>
                      </v-col> -->
                    </v-row>

                    <v-row>
                      <v-col class="py-0" cols="2">
              
                        <div class="fs-19 font-weight-bold label-input mt-3">
                          {{ item.qty_lusin }} Lusin
                        </div>
                      </v-col>
                      <!-- <v-col>
                        <div class="fs-15 label-input">
                          Harga
                        </div>

                        <div class="fs-19 font-weight-bold label-input mt-3">
                          {{ item.price | price }}
                        </div>
                      </v-col> -->

                      <v-col class="py-0">
  
                        <v-currency-field
                          
                          filled
                          rounded
                          dense
                          solo
    
                          color="#718EBF"
                          placeholder="Qty"
                          suffix="lusin"

                          
    
                          v-model="item.qty_lusin_diterima"
                          required
                          style="border-radius: 10px;">
                        </v-currency-field>
                        <!-- <div class="fs-15 label-input">
                          Qty
                        </div>

                        <v-currency-field
                          
                          filled
                          rounded
                          dense
                          solo
    
                          color="#718EBF"
                          placeholder="Qty"

                          
    
                          v-model="item.qty"
                          required
                          style="border-radius: 10px;">
                        </v-currency-field> -->
                      </v-col>
                      <v-col class="py-0">
  
                        <v-currency-field
                          
                          filled
                          rounded
                          dense
                          solo
    
                          color="#718EBF"
                          placeholder="Qty"
                          suffix="lusin"

                          
    
                          v-model="item.qty_lusin_return"
                          required
                          style="border-radius: 10px;">
                        </v-currency-field>
                        <!-- <div class="fs-15 label-input">
                          Qty
                        </div>

                        <v-currency-field
                          
                          filled
                          rounded
                          dense
                          solo
    
                          color="#718EBF"
                          placeholder="Qty"

                          
    
                          v-model="item.qty"
                          required
                          style="border-radius: 10px;">
                        </v-currency-field> -->
                      </v-col>
                      <!-- <v-col class="py-0" cols="3">
                        <ValidationProvider
                          :name="`Qty Pcs ${item.varian_name}`"
                          :rules="`required|max_value:${item.qty_pcs_approve}|min_value:0`" 
                          v-slot="{ errors }">
    
                          <v-currency-field
                          
                            filled
                            rounded
                            dense
                            solo
      
                            color="#718EBF"
                            placeholder="Qty"
                            suffix="pcs"
      
                            :value="item.qty_pcs"
                            :error-messages="errors"
                            required
                            style="border-radius: 10px;">
                          </v-currency-field>
                        </ValidationProvider>
                      </v-col> -->

                      <!-- <v-col>
                        <div class="fs-15 label-input">
                          Harga Beli
                        </div>

                        <v-currency-field
                          
                          filled
                          rounded
                          dense
                          solo
    
                          color="#718EBF"
                          placeholder="Harga Beli"
                          
    
                          v-model="item.harga_beli"
                          required
                          style="border-radius: 10px;">
                        </v-currency-field>
                      </v-col>

                      <v-col>
                        <div class="fs-15 label-input">
                          PPN Beli
                        </div>

                        <v-currency-field
                          
                          filled
                          rounded
                          dense
                          solo
    
                          color="#718EBF"
                          placeholder="PPN Beli"
                          
    
                          v-model="item.ppn_beli"
                          required
                          style="border-radius: 10px;">
                        </v-currency-field>
                      </v-col> -->
                    </v-row>

                    <v-row>
                      <v-col class="py-0" cols="2">
              
                        <div class="fs-19 font-weight-bold label-input mt-3">
                          {{ item.qty_dus }} Dus
                        </div>
                      </v-col>
                      <!-- <v-col>
                        <div class="fs-15 label-input">
                          Harga
                        </div>

                        <div class="fs-19 font-weight-bold label-input mt-3">
                          {{ item.price | price }}
                        </div>
                      </v-col> -->

                      <v-col class="py-0">
  
                        <v-currency-field
                          
                          filled
                          rounded
                          dense
                          solo
    
                          color="#718EBF"
                          placeholder="Qty"
                          suffix="dus"

                          
    
                          v-model="item.qty_dus_diterima"
                          required
                          style="border-radius: 10px;">
                        </v-currency-field>
                        <!-- <div class="fs-15 label-input">
                          Qty
                        </div>

                        <v-currency-field
                          
                          filled
                          rounded
                          dense
                          solo
    
                          color="#718EBF"
                          placeholder="Qty"

                          
    
                          v-model="item.qty"
                          required
                          style="border-radius: 10px;">
                        </v-currency-field> -->
                      </v-col>
                      <v-col class="py-0">
  
                        <v-currency-field
                          
                          filled
                          rounded
                          dense
                          solo
    
                          color="#718EBF"
                          placeholder="Qty"
                          suffix="dus"

                          
    
                          v-model="item.qty_dus_return"
                          required
                          style="border-radius: 10px;">
                        </v-currency-field>
                        <!-- <div class="fs-15 label-input">
                          Qty
                        </div>

                        <v-currency-field
                          
                          filled
                          rounded
                          dense
                          solo
    
                          color="#718EBF"
                          placeholder="Qty"

                          
    
                          v-model="item.qty"
                          required
                          style="border-radius: 10px;">
                        </v-currency-field> -->
                      </v-col>
                      <!-- <v-col class="py-0" cols="3">
                        <ValidationProvider
                          :name="`Qty Pcs ${item.varian_name}`"
                          :rules="`required|max_value:${item.qty_pcs_approve}|min_value:0`" 
                          v-slot="{ errors }">
    
                          <v-currency-field
                          
                            filled
                            rounded
                            dense
                            solo
      
                            color="#718EBF"
                            placeholder="Qty"
                            suffix="pcs"
      
                            :value="item.qty_pcs"
                            :error-messages="errors"
                            required
                            style="border-radius: 10px;">
                          </v-currency-field>
                        </ValidationProvider>
                      </v-col> -->

                      <!-- <v-col>
                        <div class="fs-15 label-input">
                          Harga Beli
                        </div>

                        <v-currency-field
                          
                          filled
                          rounded
                          dense
                          solo
    
                          color="#718EBF"
                          placeholder="Harga Beli"
                          
    
                          v-model="item.harga_beli"
                          required
                          style="border-radius: 10px;">
                        </v-currency-field>
                      </v-col>

                      <v-col>
                        <div class="fs-15 label-input">
                          PPN Beli
                        </div>

                        <v-currency-field
                          
                          filled
                          rounded
                          dense
                          solo
    
                          color="#718EBF"
                          placeholder="PPN Beli"
                          
    
                          v-model="item.ppn_beli"
                          required
                          style="border-radius: 10px;">
                        </v-currency-field>
                      </v-col> -->
                    </v-row>

                  </v-card-text>
                </v-card>
              </div>

            </v-card-text>
          </v-card>
          </div>


          <div v-if="message.error.length > 0"
            class="text-left mt-4">
            <div
              class="error--text d-flex align-start">
              <v-icon size="18" color="red" style="padding-top: 5px;">mdi-alert-circle-outline</v-icon>
              
              <span
                class="ml-1">
                {{ message.error }}
              </span>
            </div>
          </div>
        </v-card-text>


        <!-- <v-divider 
          class="mt-2"
          style="border-top: 2px dashed #e0e0e0;"/> -->

        <v-card-actions
          class="pa-0 pt-4">
          <v-spacer/>

          <v-btn
            rounded
            @click="save()"
            :loading="process.form"
            :disabled="process.form"
            width="190"
            height="45"
            elevation="0"
            color="#1814F3"
            class="fs-16 white--text text-capitalize border-radius">
            Ya, {{ message.status }}
          </v-btn>

          <!-- <v-btn
            rounded
            width="120"
            @click="dialog.status = false; dialog.fullscreen = false; selected.status = [];"
            :disabled="process.status"
            outlined
            class="body-2 font-weight-bold text-capitalize red--text">
            Batal
          </v-btn> -->
              </v-card-actions>
            </v-card>
          </v-dialog>

          <v-dialog v-model="dialog.delete"
            @keydown.esc="dialog.delete = false"
            :fullscreen="dialog.fullscreen"
            width="500"
            persistent
            scrollable>
            <v-card 
        :class="dialog.fullscreen ? 'non-border-radius' : 'border-radius-card'"
        class="pa-6 pt-6">
        <v-card-title 
          class="d-flex align-center pa-0 pb-4 text-right popup-header fs-18 font-weight-bold">
          
          Hapus Data

          <v-spacer/>

          <!-- <v-icon 
            @click="dialog.fullscreen = !dialog.fullscreen ? true : false"
            class="cursor-pointer mr-1"
            size="24"
            color="#718EBF">
            {{ !dialog.fullscreen ? 'mdi-fullscreen' : 'mdi-fullscreen-exit' }}
          </v-icon>

          <v-icon 
            @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
            class="cursor-pointer"
            size="24"
            color="red">
            mdi-close-circle-outline
          </v-icon> -->

          <v-icon 
            @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
            class="cursor-pointer"
            size="18"
            color="#000000">
            mdi-close
          </v-icon>
        </v-card-title>
        
        <!-- <v-divider 
          class="mb-2"
          style="border-top: 2px dashed #e0e0e0;"/> -->

        <v-card-text 
          class="body-1 font-weight-light text-first line-text-second my-0 px-0 py-3">
          Apakah Anda yakin menghapus data <b class="font-weight-bold black--text">BPB</b> yang Anda pilih?

          <div v-if="message.error.length > 0"
            class="text-center mt-4">
            <div
              class="error--text d-flex align-start">
              <v-icon size="18" color="red" style="margin-top: 3px;">mdi-alert-circle-outline</v-icon>
              
              <span
                class="ml-1">
                {{ message.error }}
              </span>
            </div>
          </div>
        </v-card-text>


        <!-- <v-divider 
          class="mt-2"
          style="border-top: 2px dashed #e0e0e0;"/> -->

        <v-card-actions
          class="pa-0 pt-4">
          <v-spacer/>

          <v-btn
            rounded
            @click="deletes()"
            :loading="process.delete"
            :disabled="process.delete"
            width="190"
            height="45"
            elevation="0"
            color="#1814F3"
            class="fs-16 white--text text-capitalize border-radius">
            Ya, Hapus
          </v-btn>

          <!-- <v-btn
            rounded
            width="120"
            @click="dialog.delete = false; dialog.fullscreen = false; selected.delete = [];"
            :disabled="process.delete"
            outlined
            class="body-2 font-weight-bold text-capitalize red--text">
            Batal
          </v-btn> -->
            </v-card-actions>
          </v-card>
        </v-dialog>

        <v-snackbar
          v-model="dialog.snackbar"
          top
          right
          color="green">
          <span 
            class="body-1 font-weight-light white--text"
            v-html="message.success">
          </span>

          <template v-slot:action="{ attrs }">
            <v-btn
              icon
              color="white"
              class="body-1 font-weight-bold text-capitalize"
              v-bind="attrs"
              @click="dialog.snackbar = false">
              <v-icon>mdi-close-circle-outline</v-icon>
            </v-btn>
          </template>
        </v-snackbar>

        <!-- Error Toast -->
        <v-slide-y-transition>
          <div v-if="message.error" class="error-toast">
            <v-icon color="white" size="20">mdi-alert-circle</v-icon>
            <span>{{ message.error }}</span>
            <button type="button" @click="message.error = ''">
              <v-icon color="white" size="16">mdi-close</v-icon>
            </button>
          </div>
        </v-slide-y-transition>

            <!-- Page Header -->
            <div class="page-header">
              <div class="header-content px-2">
                <div class="d-flex">
                  <h1>Detail Proses Muat</h1>
                  <div v-if="Object.keys(detail).length > 0" class="header-badge ml-2" :style="`background: ${getStatusColor(detail.status)};`">
                    <v-icon size="14" color="white">mdi-file-document-outline</v-icon>
                    <span>{{ getStatusText(detail.status) }}</span>
                  </div>
                  <div v-if="$route.query.is_ekspedisi == 1 || $route.query.is_ekspedisi == '1'" class="header-badge ml-2" style="background: linear-gradient(135deg, #F07B3F 0%, #F07B3F 100%);">
                    <v-icon size="14" color="white">mdi-truck-delivery</v-icon>
                    <span>Pakai Ekspedisi</span>
                  </div>
                </div>
                <p v-if="Object.keys(detail).length > 0">Informasi lengkap proses muat {{ detail.number }}</p>
                <p v-else>Memuat data proses muat...</p>
              </div>
            </div>

            <!-- Main Content -->
            <div class="main-card">
              <!-- Loading State -->
              <div v-if="process.load" class="loading-container">
                <v-progress-circular
                  indeterminate
                  color="#00ADB5"
                  size="64"
                  width="6"
                  class="mb-4">
                </v-progress-circular>
                <div class="fs-16 font-weight-medium" style="color: #495057;">
                  Memuat Data Proses Muat...
                </div>
                <div class="fs-12 mt-2" style="color: #6c757d;">
                  Mohon tunggu sebentar
                </div>
              </div>

              <!-- Detail Information -->
              <div v-if="!process.load && Object.keys(detail).length > 0" class="form-step">
                <div class="step-header">
                  <div class="step-icon teal">
                    <v-icon color="white" size="28">mdi-file-document-outline</v-icon>
                  </div>
                  <div>
                    <h2>Informasi Surat Jalan</h2>
                    <p>Detail lengkap surat jalan pengiriman</p>
                  </div>
                </div>

                <!-- Info Grid Normal (Non-Ekspedisi) -->
                <div v-if="!$route.query.is_ekspedisi || ($route.query.is_ekspedisi != 1 && $route.query.is_ekspedisi != '1')" class="info-grid">
                  <div class="info-card">
                    <div class="info-label">
                      <v-icon size="16" class="mr-2" color="#00ADB5">mdi-identifier</v-icon>
                      No. Surat Jalan
                    </div>
                    <div class="info-value">{{ detail.number }}</div>
                  </div>
                  <div class="info-card">
                    <div class="info-label">
                      <v-icon size="16" class="mr-2" color="#00ADB5">mdi-account-circle</v-icon>
                      Nama Driver
                    </div>
                    <div class="info-value">{{ detail.driver_name }}</div>
                  </div>
                  <div class="info-card">
                    <div class="info-label">
                      <v-icon size="16" class="mr-2" color="#00ADB5">mdi-truck</v-icon>
                      Nama Kendaraan
                    </div>
                    <div class="info-value">{{ detail.vehicle_name }} - {{ detail.vehicle_number }}</div>
                  </div>
                  <div class="info-card">
                    <div class="info-label">
                      <v-icon size="16" class="mr-2" color="#00ADB5">mdi-calendar</v-icon>
                      Tanggal Pengiriman
                    </div>
                    <div class="info-value">{{ detail.date | date }}</div>
                  </div>
                  <div class="info-card">
                    <div class="info-label">
                      <v-icon size="16" class="mr-2" color="#00ADB5">mdi-information</v-icon>
                      Status
                    </div>
                    <div class="info-value">
                      <v-chip 
                        small
                        :color="getStatusColor(detail.status)"
                        text-color="white"
                        style="font-weight: 600;">
                        {{ getStatusText(detail.status) }}
                      </v-chip>
                    </div>
                  </div>
                  <div class="info-card full-width">
                    <div class="info-label">
                      <v-icon size="16" class="mr-2" color="#00ADB5">mdi-note-text</v-icon>
                      Catatan
                    </div>
                    <div class="info-value">{{ detail.note === '' ? '-' : detail.note }}</div>
                  </div>
                </div>

                <!-- Card Ekspedisi (Jika Pakai Ekspedisi) -->
                <div v-if="$route.query.is_ekspedisi == 1 || $route.query.is_ekspedisi == '1'">
                  <div class="info-grid mb-4">
                    <div class="info-card">
                      <div class="info-label">
                        <v-icon size="16" class="mr-2" color="#00ADB5">mdi-identifier</v-icon>
                        No. Surat Jalan
                      </div>
                      <div class="info-value">{{ detail.number }}</div>
                    </div>
                    <div class="info-card">
                      <div class="info-label">
                        <v-icon size="16" class="mr-2" color="#00ADB5">mdi-information</v-icon>
                        Status
                      </div>
                      <div class="info-value">
                        <v-chip 
                          small
                          :color="getStatusColor(detail.status)"
                          text-color="white"
                          style="font-weight: 600;">
                          {{ getStatusText(detail.status) }}
                        </v-chip>
                      </div>
                    </div>
                    <div class="info-card full-width">
                      <div class="info-label">
                        <v-icon size="16" class="mr-2" color="#00ADB5">mdi-note-text</v-icon>
                        Catatan
                      </div>
                      <div class="info-value">{{ detail.note === '' ? '-' : detail.note }}</div>
                    </div>
                  </div>

                  <v-card 
                    flat 
                    class="pa-5 mt-4 elegant-ekspedisi-card" 
                    style="background: linear-gradient(135deg, #E8F4F8 0%, #A8D5E2 100%); border-radius: 6px; box-shadow: 0 4px 20px rgba(15, 76, 117, 0.12);">
                    <div class="d-flex align-center mb-4">
                      <v-avatar size="36" style="background: linear-gradient(135deg, #3282B8 0%, #5C9EAD 100%); box-shadow: 0 4px 12px rgba(50, 130, 184, 0.3);" class="mr-3">
                        <v-icon color="white" size="18">mdi-truck-delivery</v-icon>
                      </v-avatar>
                      <div>
                        <div class="fs-17 font-weight-bold" style="color: #2E5266; letter-spacing: -0.3px;">
                          Informasi Ekspedisi
                        </div>
                        <div class="fs-11 mt-1" style="color: #5C9EAD;">
                          Data ekspedisi untuk pengiriman
                        </div>
                      </div>
                    </div>
                    <v-row>
                      <v-col cols="12" md="4">
                        <div class="fs-14 font-weight-semibold mb-3" style="color: #2E5266; letter-spacing: -0.2px;">
                          Nama Driver Ekspedisi
                        </div>
                        <div class="ekspedisi-info-box">
                          <v-icon size="18" class="mr-2" color="#3282B8">mdi-account</v-icon>
                          <span class="ekspedisi-info-value">{{ detail.driver_name || '-' }}</span>
                        </div>
                      </v-col>
                      <v-col cols="12" md="4">
                        <div class="fs-14 font-weight-semibold mb-3" style="color: #2E5266; letter-spacing: -0.2px;">
                          Nama Kendaraan Ekspedisi
                        </div>
                        <div class="ekspedisi-info-box">
                          <v-icon size="18" class="mr-2" color="#3282B8">mdi-truck</v-icon>
                          <span class="ekspedisi-info-value">{{ detail.vehicle_name || '-' }}</span>
                        </div>
                      </v-col>
                      <v-col cols="12" md="4">
                        <div class="fs-14 font-weight-semibold mb-3" style="color: #2E5266; letter-spacing: -0.2px;">
                          Nomor Polisi Kendaraan
                        </div>
                        <div class="ekspedisi-info-box">
                          <v-icon size="18" class="mr-2" color="#3282B8">mdi-numeric</v-icon>
                          <span class="ekspedisi-info-value">{{ detail.vehicle_number || '-' }}</span>
                        </div>
                      </v-col>
                    </v-row>
                  </v-card>
                </div>
              </div>

              <!-- Detail BPB Section -->
              <div v-if="!process.load && Object.keys(detail).length > 0" class="form-step">
                <ValidationObserver 
                  ref="form">
                  <v-form>
                    <div class="step-header">
                      <div class="step-icon orange">
                        <v-icon color="white" size="28">mdi-format-list-bulleted</v-icon>
                      </div>
                      <div>
                        <h2>Detail BPB</h2>
                        <p>Daftar BPB dalam proses muat ini</p>
                      </div>
                      <v-chip 
                        v-if="detail.bpb && detail.bpb.length > 0"
                        small
                        color="#00ADB5"
                        text-color="white"
                        class="ml-auto"
                        style="font-weight: 600;">
                        {{ detail.bpb.length }} BPB
                      </v-chip>
                    </div>
    
                  <div v-if="Object.keys(detail).length > 0">
    
                    <v-card flat style="border-radius: 6px; border: 1px solid #E7E7E7;" class="pb-7 mt-2 mb-5"  v-for="(items, indexs) in detail.bpb" :key="indexs">
                        <v-card-text>
                          <v-row>
                            <v-col class="pt-0">
                              <div class="fs-14" style="margin-bottom: 1px;">
                                No. BPB
                              </div>
                              <div class="fs-16 label-input font-weight-bold">
                                {{ items.bpb_number }}
                              </div>
                            </v-col>
    
                            <v-col class="pt-0">
                              <div class="fs-14" style="margin-bottom: 1px;">
                                Nama Customer
                              </div>
                              <div class="fs-16 label-input font-weight-bold">
                                {{ items.customer_name }}
                              </div>
                            </v-col>
    
                            <v-col class="pt-0">
                              <div class="fs-14" style="margin-bottom: 1px;">
                                No. Order
                              </div>
                              <div class="fs-16 label-input font-weight-bold">
                                {{ items.orders_number }}
                              </div>
                            </v-col>
    
                            <v-col class="pt-0" v-if="items.bpb_diterima_date !== undefined && items.bpb_diterima_date !== null">
                              <div class="fs-14" style="margin-bottom: 1px;">
                                Tanggal Barang Diterima
                              </div>
                              <div class="fs-16 label-input font-weight-bold">
                                {{ items.bpb_diterima_date | date }}
                              </div>
                            </v-col>

                            <!-- <v-col class="text-right">
                              <div class="text-right">
                                <v-tooltip bottom>
                                  <template v-slot:activator="{ on, attrs }">
                                    <v-btn
                                      @click="exports(items.bpb_id); selected.item = items.bpb_id"
                                      :loading="process.export && selected.item === items.bpb_id"
                                      :disabled="process.export && selected.item === items.bpb_id"
                                      elevation="0"
                                      min-height="28"
                                      small
                                      min-width="28"
                                      color="#bd1112"
                                      class="text-capitalize px-0 mx-1"
                                      style="border-radius: 6px;"
                                      v-bind="attrs"
                                      v-on="on">
                                      <v-icon size="18" color="white">mdi-file-pdf-box</v-icon>
                                    </v-btn>
                                  </template>

                                  <span>
                                    Export Pdf
                                  </span>
                                </v-tooltip>
                              </div>
                            </v-col> -->
                          </v-row>

                          <div v-if="($route.query.is_ekspedisi == 1 || $route.query.is_ekspedisi == '1') && detail.is_muat === '0'">
                            <div>
                              <div class="fs-14 font-weight-semibold mb-3" style="color: #2E5266; letter-spacing: -0.2px;">
                                Biaya Kirim
                              </div>
                              <v-currency-field
                                v-model="bpb_array_biaya_kirim[indexs].bpb_biaya_kirim"
                                filled
                                rounded
                                dense
                                solo
                                prefix="Rp"
                                color="#718EBF"
                              />
                            </div>
                          </div>
                          <div class="mb-2" v-if="detail.status !== 'diterima' && isSuperAdmin">
                            <v-btn
                              @click="toDelete(items.bpb_id)"
                              min-width="28"
                              small
                              rounded
                              color="red"
                              elevation="0"
                              class="white--text text-capitalize mx-1"
                              style="font-weight: 600; border-radius: 6px;">
                              Hapus BPB
                            </v-btn>
                          </div>
                          <table width="100%" style="border: thin solid #E6EFF5;">
                            <thead>
                              <tr>
                                <!-- <th class="text-center black--text fs-14 font-weight-bold pa-2" style="border-top: thin solid #E6EFF5; border-right: thin solid #E6EFF5;  border-bottom: thin solid #E6EFF5">Aksi</th> -->
                                <th class="text-left black--text fs-14 font-weight-bold pa-2" style="border-top: thin solid #E6EFF5; border-right: thin solid #E6EFF5;  border-bottom: thin solid #E6EFF5">Nama Barang</th>
                                <th class="text-left black--text fs-14 font-weight-bold pa-2" style="border-top: thin solid #E6EFF5; border-right: thin solid #E6EFF5; border-bottom: thin solid #E6EFF5">No. SKU</th>
                                <th class="text-left black--text fs-14 font-weight-bold pa-2" style="border-top: thin solid #E6EFF5; border-bottom: thin solid #E6EFF5; border-right: thin solid #E6EFF5;">{{ detail.status === 'Set Order' ? 'Qty yang akan dikirim' : 'Qty yang dikirim' }}</th>
                                <th class="text-left black--text fs-14 font-weight-bold pa-2" style="border-top: thin solid #E6EFF5; border-bottom: thin solid #E6EFF5; border-right: thin solid #E6EFF5;">Qty Dus Muat</th>
                                <th class="text-left black--text fs-14 font-weight-bold pa-2" style="border-top: thin solid #E6EFF5; border-bottom: thin solid #E6EFF5">Qty Dus Rusak</th>
                              </tr>
                            </thead>
                            <tbody>
                              <tr v-for="(item, index) in items.detail" :key="index">
                                <!-- <td class="sticky-col one-col" style="font-size: 12px; border: 1px solid #ededed; border-left: none; width: 60px; min-width: 60px; max-width: 60px; padding: 8px 12px; text-align: center;">
                                  <v-tooltip 
                                    top>
                                    <template v-slot:activator="{ on, attrs }">
                                      <v-btn
                                        @click="toDelete(item.bpb_detail_id)"

                                        v-bind="attrs"
                                        v-on="on"

                                        min-width="28"
                                        small
                                        rounded
                                        color="red"
                                        elevation="0"
                                        class="white--text text-capitalize mx-1 px-0"
                                        style="font-weight: 600; border-radius: 6px;">
                                        <v-icon small>mdi-trash-can-outline</v-icon>
                                      </v-btn>
                                    </template>
                                    
                                    <span>Hapus</span>
                                  </v-tooltip>
                                </td> -->
                                <td class="text-left black--text label-input fs-14 pa-2" style="vertical-align: sub; border-top: thin solid #E6EFF5; border-right: thin solid #E6EFF5;  border-bottom: thin solid #E6EFF5">{{ item.varian_name }}</td>
                                <td class="text-left black--text label-input fs-14 pa-2" style="vertical-align: sub; border-top: thin solid #E6EFF5; border-right: thin solid #E6EFF5;  border-bottom: thin solid #E6EFF5">{{ item.varian_sku }}</td>
                                <td class="text-left black--text label-input fs-14 pa-2" style="vertical-align: sub; border-top: thin solid #E6EFF5; border-right: thin solid #E6EFF5;  border-bottom: thin solid #E6EFF5">
                                  <div v-if="item.qty_pcs*1 > 0">
                                    {{ item.qty_pcs }} Pcs
                                  </div>
                                  <div v-if="item.qty_lusin*1 > 0">
                                    {{ item.qty_lusin }} Lusin
                                  </div>
                                  <div v-if="item.qty_dus*1 > 0">
                                    {{ item.qty_dus }} {{ (item.qty_in_dus*1) > 1 ? 'Dus' : 'Pcs' }}
                                  </div>
                                </td>
                                <td class="text-left black--text label-input fs-14 pa-2" style="vertical-align: sub; border-top: thin solid #E6EFF5; border-right: thin solid #E6EFF5;  border-bottom: thin solid #E6EFF5">
                                  <div v-if="detail.is_muat === '1'">
                                    {{ item.qty_dus_muat }} {{ (item.qty_in_dus*1) > 1 ? 'Dus' : 'Pcs' }}
                                  </div>
                                  <div v-if="detail.is_muat === '0'">
                                    <ValidationProvider
                                      :name="`Qty Dus Muat ${item.varian_name}`"
                                      :rules="`required|min_value:0|max_value:${item.qty_dus}`" 
                                      v-slot="{ errors }">
                
                                      <v-currency-field
                                      
                                        filled
                                        rounded
                                        dense
                                        solo
                  
                                        color="#718EBF"
                                        placeholder="Qty Dus Muat"
                                        :suffix="item.qty_in_dus*1 > 1 ? 'Dus' : 'Pcs'"
                                        
                  
                                        v-model="item.qty_dus_muat"
                                        :error-messages="errors"
                                        required
                                        style="border-radius: 10px;">
                                      </v-currency-field>
                                    </ValidationProvider>
                                  </div>
                                </td>
                                <td class="text-left black--text label-input fs-14 pa-2" style="vertical-align: sub; border-top: thin solid #E6EFF5; border-right: thin solid #E6EFF5;  border-bottom: thin solid #E6EFF5">
                                  <div v-if="detail.is_muat === '1'">
                                    {{ item.qty_dus_rusak }} Dus
                                  </div>
                                  <div v-if="detail.is_muat === '0'">
                                    <ValidationProvider
                                      :name="`Qty Dus Rusak ${item.varian_name}`"
                                      :rules="`required|min_value:0|max_value:${item.qty_dus}`" 
                                      v-slot="{ errors }">
                
                                      <v-currency-field
                                      
                                        filled
                                        rounded
                                        dense
                                        solo
                  
                                        color="#718EBF"
                                        placeholder="Qty Dus Rusak"
                                        suffix="Dus"
                                        
                  
                                        v-model="item.qty_dus_rusak"
                                        :error-messages="errors"
                                        required
                                        style="border-radius: 10px;">
                                      </v-currency-field>
                                    </ValidationProvider>
                                  </div>
                                </td>
                              </tr>
                            </tbody>
                          </table>
                          <div v-for="(item, index) in items.detail" :key="index">
                            <!-- {{ index+items.bpb_id }} -->
                            <!-- <table width="100%" style="border-bottom: thin solid #E6EFF5;">
                              <thead>
                                <tr>
                                  <th class="text-left fs-14 font-weight-bold pa-2" style="border-top: thin solid #E6EFF5; border-bottom: thin solid #E6EFF5">Nama Barang</th>
                                  <th class="text-left fs-14 font-weight-bold pa-2" style="border-top: thin solid #E6EFF5; border-bottom: thin solid #E6EFF5">No. SKU</th>
                                  <th class="text-left fs-14 font-weight-bold pa-2" style="border-top: thin solid #E6EFF5; border-bottom: thin solid #E6EFF5">Qty</th>
                                  <th class="text-left fs-14 font-weight-bold pa-2" style="border-top: thin solid #E6EFF5; border-bottom: thin solid #E6EFF5">Qty Lusin</th>
                                  <th class="text-left fs-14 font-weight-bold pa-2" style="border-top: thin solid #E6EFF5; border-bottom: thin solid #E6EFF5">Qty Dus</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr v-for="(item, index) in form.varian_arr" :key="index">
                                  <td class="text-left label-input fs-16 font-weight-bold pa-2">{{ item.detail_varian_name }}</td>
                                  <td class="text-left label-input fs-16 font-weight-bold pa-2">{{ item.detail_varian_sku }}</td>
                                  <td class="text-left label-input fs-16 font-weight-bold pa-2">{{ item.detail_qty_pcs_approved }}</td>
                                  <td class="text-left label-input fs-16 font-weight-bold pa-2">{{ item.detail_qty_lusin_approved }}</td>
                                  <td class="text-left label-input fs-16 font-weight-bold pa-2">{{ item.detail_qty_dus_approved }}</td>
                                </tr>
                              </tbody>
                            </table> -->
                            <!-- <v-card flat class="mb-5" style="background: #718ebf17; border-radius: 15px;">
                              <v-card-text>
                                <div class="fs-16 font-weight-bold label-input">
                                  {{ item.varian_name }}
                                </div>
                                <div>
                                  <span>Kode SKU</span>: <span>{{ item.varian_sku }}</span>
                                </div>
        
                                <v-row class="pt-3 pb-0">
                                  <v-col class="py-0" cols="12" md="4">
                                    <div 
                                      class="fs-15 label-input" v-if="detail.status === 'Set Order'">
                                      Qty yang akan dikirim
                                    </div>
                                    <div 
                                      class="fs-15 label-input" v-if="detail.status !== 'Set Order'">
                                      Qty yang dikirim
                                    </div>
                                  </v-col>
    
                                  <v-col class="py-0" cols="12" md="4"  v-if="detail.status === 'diterima' || detail.status == 'pengiriman terkonfirmasi'">
                                    <div 
                                      class="fs-15 label-input">
                                      Qty yang diterima
                                    </div>
                                  </v-col>
    
                                  <v-col class="py-0" cols="12" md="4"  v-if="detail.status === 'diterima' || detail.status == 'pengiriman terkonfirmasi'">
                                    <div 
                                      class="fs-15 label-input">
                                      Qty yang dikembalikan
                                    </div>
                                  </v-col>
                                </v-row>
        
                                <v-row v-if="item.qty_pcs*1 > 0">
        
                                  <v-col class="py-0" cols="12" md="4">
              
                                    <div class="fs-19 font-weight-bold label-input">
                                      {{ item.qty_pcs }} Pcs
                                    </div>
                                  </v-col>
                                  <v-col class="py-0" cols="12" md="4" v-if="detail.status === 'diterima' || detail.status == 'pengiriman terkonfirmasi'">
                                    
                                    <div class="fs-19 font-weight-bold label-input">
                                      {{ item.qty_pcs_diterima }} Pcs
                                    </div>
                                  </v-col>
                                  <v-col class="py-0" cols="12" md="4" v-if="detail.status === 'diterima' || detail.status == 'pengiriman terkonfirmasi'">
              
                                    <div class="fs-19 font-weight-bold label-input">
                                      {{ item.qty_pcs_return }} Pcs
                                    </div>
                                  </v-col>
                                </v-row>
        
                                <v-row v-if="item.qty_lusin*1 > 0">
        
                                  <v-col class="py-0" cols="12" md="4">
              
                                    <div class="fs-19 font-weight-bold label-input">
                                      {{ item.qty_lusin }} Lusin
                                    </div>
                                  </v-col>
                                  <v-col class="py-0" cols="12" md="4" v-if="detail.status === 'diterima' || detail.status == 'pengiriman terkonfirmasi'">
              
                                    <div class="fs-19 font-weight-bold label-input">
                                      {{ item.qty_lusin_diterima }} Lusin
                                    </div>
                                  </v-col>
                                  <v-col class="py-0" cols="12" md="4" v-if="detail.status === 'diterima' || detail.status == 'pengiriman terkonfirmasi'">
              
                                    <div class="fs-19 font-weight-bold label-input">
                                      {{ item.qty_lusin_return }} Lusin
                                    </div>
                                  </v-col>
                                </v-row>
        
                                <v-row v-if="item.qty_dus*1 > 0">
                                  <v-col class="py-0" cols="12" md="4">
                                    
                                    <div class="fs-19 font-weight-bold label-input">
                                      {{ item.qty_dus }} dus
                                    </div>
                                  </v-col>
                                  <v-col class="py-0" cols="12" md="4" v-if="detail.status === 'diterima' || detail.status == 'pengiriman terkonfirmasi'">
              
                                    <div class="fs-19 font-weight-bold label-input">
                                      {{ item.qty_dus_diterima }} Dus
                                    </div>
                                  </v-col>
                                  <v-col class="py-0" cols="12" md="4" v-if="detail.status === 'diterima' || detail.status == 'pengiriman terkonfirmasi'">
              
                                    <div class="fs-19 font-weight-bold label-input">
                                      {{ item.qty_dus_return }} Dus
                                    </div>
                                  </v-col>
                                </v-row>
        
                              </v-card-text>
                            </v-card> -->
                          </div>
      
                      </v-card-text>
                    </v-card>
                  </div>
                  </v-form>
                </ValidationObserver>

                <!-- Upload Foto Ekspedisi (Jika Pakai Ekspedisi) -->
                <div v-if="($route.query.is_ekspedisi == 1 || $route.query.is_ekspedisi == '1')" class="pb-8 pt-6">
                  <div class="step-header">
                    <div class="step-icon coral">
                      <v-icon color="white" size="28">mdi-camera</v-icon>
                    </div>
                    <div>
                      <h2>Foto Ekspedisi</h2>
                      <p>Upload foto driver dan kendaraan ekspedisi</p>
                    </div>
                  </div>

                  <v-row>
                    <v-col cols="12" md="6">
                      <div class="fs-14 font-weight-semibold mb-3" style="color: #2E5266; letter-spacing: -0.2px;">
                        <span class="red--text">*</span>
                        Foto Driver Ekspedisi
                      </div>
                      <div v-if="detail.is_muat === '0'">
                        <uploadfolder v-if="ekspedisi_driver_photo_url === ''"
                          v-model="upload.ekspedisi_driver_photo">
                          <div slot="activator">
                            <v-card 
                              flat
                              class="d-flex align-center justify-center cursor-pointer"
                              style="border-radius: 10px; border: 2px dashed #d0d5dd; min-height: 200px; background: #fafbfc; transition: all 0.3s ease;"
                              :class="{ 'upload-hover': !process.ekspedisi_driver_photo }">
                              <v-progress-circular v-if="process.ekspedisi_driver_photo"
                                indeterminate
                                color="#00ADB5"
                                size="48"
                                width="4">
                              </v-progress-circular>
                              <div v-else class="text-center pa-4">
                                <v-icon size="48" color="#9ca3af" class="mb-3">mdi-cloud-upload-outline</v-icon>
                                <div class="fs-14 font-weight-medium" style="color: #6b7280;">
                                  Klik untuk upload foto driver
                                </div>
                                <div class="fs-12 mt-1" style="color: #9ca3af;">
                                  Format: JPG, PNG (Max 5MB)
                                </div>
                              </div>
                            </v-card>
                          </div>
                        </uploadfolder>
                        <v-card v-if="ekspedisi_driver_photo_url !== ''"
                          flat
                          class="position-relative"
                          style="border-radius: 10px; overflow: hidden; border: 2px solid #e8eaed;">
                          <v-img 
                            :src="ekspedisi_driver_photo_url"
                            height="200"
                            contain
                            style="background: #f8f9fa;">
                            <template v-slot:placeholder>
                              <v-row class="fill-height" align="center" justify="center">
                                <v-progress-circular indeterminate color="#00ADB5"></v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>
                          <v-btn
                            @click="ekspedisi_driver_photo_url = ''"
                            icon
                            small
                            absolute
                            top
                            right
                            color="red"
                            style="margin: 8px;">
                            <v-icon size="20">mdi-close</v-icon>
                          </v-btn>
                        </v-card>
                      </div>
                      <div v-if="detail.is_muat === '1'">
                        <v-img 
                          :src="detail.driver_photo_url"
                          height="200"
                          contain
                          style="background: #f8f9fa;">
                          <template v-slot:placeholder>
                            <v-row class="fill-height" align="center" justify="center">
                              <v-progress-circular indeterminate color="#00ADB5"></v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </div>
                    </v-col>
                    <v-col cols="12" md="6">
                      <div class="fs-14 font-weight-semibold mb-3" style="color: #2E5266; letter-spacing: -0.2px;">
                        <span class="red--text">*</span>
                        Foto Kendaraan Ekspedisi
                      </div>
                      <div v-if="detail.is_muat === '0'">
                        <uploadfolder v-if="ekspedisi_vehicle_photo_url === ''"
                          v-model="upload.ekspedisi_vehicle_photo">
                          <div slot="activator">
                            <v-card 
                              flat
                              class="d-flex align-center justify-center cursor-pointer"
                              style="border-radius: 10px; border: 2px dashed #d0d5dd; min-height: 200px; background: #fafbfc; transition: all 0.3s ease;"
                              :class="{ 'upload-hover': !process.ekspedisi_vehicle_photo }">
                              <v-progress-circular v-if="process.ekspedisi_vehicle_photo"
                                indeterminate
                                color="#00ADB5"
                                size="48"
                                width="4">
                              </v-progress-circular>
                              <div v-else class="text-center pa-4">
                                <v-icon size="48" color="#9ca3af" class="mb-3">mdi-cloud-upload-outline</v-icon>
                                <div class="fs-14 font-weight-medium" style="color: #6b7280;">
                                  Klik untuk upload foto kendaraan
                                </div>
                                <div class="fs-12 mt-1" style="color: #9ca3af;">
                                  Format: JPG, PNG (Max 5MB)
                                </div>
                              </div>
                            </v-card>
                          </div>
                        </uploadfolder>
                        <v-card v-if="ekspedisi_vehicle_photo_url !== ''"
                          flat
                          class="position-relative"
                          style="border-radius: 10px; overflow: hidden; border: 2px solid #e8eaed;">
                          <v-img 
                            :src="ekspedisi_vehicle_photo_url"
                            height="200"
                            contain
                            style="background: #f8f9fa;">
                            <template v-slot:placeholder>
                              <v-row class="fill-height" align="center" justify="center">
                                <v-progress-circular indeterminate color="#00ADB5"></v-progress-circular>
                              </v-row>
                            </template>
                          </v-img>
                          <v-btn
                            @click="ekspedisi_vehicle_photo_url = ''"
                            icon
                            small
                            absolute
                            top
                            right
                            color="red"
                            style="margin: 8px;">
                            <v-icon size="20">mdi-close</v-icon>
                          </v-btn>
                        </v-card>
                      </div>
                      <div v-if="detail.is_muat === '1'">
                        <v-img 
                          :src="detail.vehicle_photo_url"
                          height="200"
                          contain
                          style="background: #f8f9fa;">
                          <template v-slot:placeholder>
                            <v-row class="fill-height" align="center" justify="center">
                              <v-progress-circular indeterminate color="#00ADB5"></v-progress-circular>
                            </v-row>
                          </template>
                        </v-img>
                      </div>
                    </v-col>
                  </v-row>
                </div>

                <!-- Tabel Invoice -->
                <div v-if="!process.load && Object.keys(detail).length > 0 && ($route.query.is_ekspedisi == 1 || $route.query.is_ekspedisi == '1') && detail.is_muat === '0' && detail.bpb && detail.bpb.length > 0">
                  <div class="step-header">
                    <div class="step-icon purple">
                      <v-icon color="white" size="28">mdi-file-document-outline</v-icon>
                    </div>
                    <div>
                      <h2>Tabel Invoice</h2>
                      <p>Detail invoice per Sales Order</p>
                    </div>
                  </div>

                  <!-- Loop untuk setiap BPB yang memiliki SO -->
                  <div v-for="(bpb, bpbIndex) in detail.bpb" :key="bpbIndex" v-if="bpb.orders_id && order_lists[bpb.bpb_id]">
                    <v-card flat class="mb-6" style="border-radius: 6px; border: 1px solid #E7E7E7;">
                      <v-card-text>
                        <div class="mb-4">
                          <div class="fs-16 font-weight-bold mb-2">
                            {{ bpb.orders_number }} - {{ bpb.customer_name }}
                          </div>
                          <div class="fs-13" style="color: #6b7280;">
                            BPB: {{ bpb.bpb_number }}
                          </div>
                        </div>

                        <v-row>
                          <v-col cols="12" class="my-4">
                            <div style="overflow: auto; " class="fs-13">
                              <table style="width: 100%;">
                                <tr>
                                  <td style="height: 70px; border: 1px solid #ededed; padding: 10px;" class="font-weight-bold text-center">
                                    Kode Barang
                                  </td>
                                  <td style="height: 70px; border: 1px solid #ededed; padding: 10px;" class="font-weight-bold text-center">
                                    Nama Barang
                                  </td>
                                  <td style="height: 70px; border: 1px solid #ededed; padding: 10px;" class="font-weight-bold text-center">
                                    Quantity
                                  </td>
                                  <td style="height: 70px; border: 1px solid #ededed; padding: 10px;" class="font-weight-bold text-center">
                                    Harga Per Unit
                                  </td>
                                  <td style="height: 70px; border: 1px solid #ededed; padding: 10px;" class="font-weight-bold text-center">
                                    Harga Bruto
                                  </td>
                                  <td style="height: 70px; border: 1px solid #ededed; padding: 10px;" class="font-weight-bold text-center">
                                    Diskon Promo
                                  </td>
                                  <td style="height: 70px; border: 1px solid #ededed; padding: 10px;" class="font-weight-bold text-center">
                                    Diskon Strata
                                  </td>
                                  <td style="height: 70px; border: 1px solid #ededed; padding: 10px;" class="font-weight-bold text-center">
                                    Harga Net. 
                                  </td>
                                </tr>
                                <tr v-for="(item, index) in order_lists[bpb.bpb_id].detail" :key="index">
                                  <td style="border: 1px solid #ededed; padding: 10px;" class="">
                                    {{ item.detail_varian_sku }}
                                  </td>
                                  <td style="border: 1px solid #ededed; padding: 10px;" class="">
                                    {{ item.detail_varian_name }}
                                  </td>
                                  <td style="border: 1px solid #ededed; padding: 10px;" class="">
                                    {{ getQuantityStringInvoice(item, bpb.bpb_id) }}
                                  </td>
                                  <td style="border: 1px solid #ededed; padding: 10px;" class="text-right">
                                    <span v-if="item.detail_qty_pcs !== 0">
                                      Rp. {{ item.detail_price_per_pcs | number_dec }}
                                    </span>
                                    <span v-else-if="item.detail_qty_lusin !== 0">
                                      Rp. {{ (item.detail_price_per_pcs*12) | number_dec }}
                                    </span>
                                    <span v-else-if="item.detail_qty_dus !== 0">
                                      Rp. {{ Math.round(item.detail_price_per_pcs*item.detail_total_in_dus) | number_dec }}
                                    </span>
                                  </td>
                                  <td style="border: 1px solid #ededed; padding: 10px;" class="text-right">
                                    {{ getHargaBrutoInvoice(item, bpb.bpb_id) | price }}
                                  </td>
                                  <td style="border: 1px solid #ededed; padding: 10px;" class="text-center">
                                    {{ (((item.detail_discount*1))) | price }}
                                  </td>
                                  <td style="border: 1px solid #ededed; padding: 10px;" class="text-center">
                                    {{ getDiskonStrataInvoice(item, bpb.bpb_id) | price }}
                                  </td>
                                  <td style="border: 1px solid #ededed; padding: 10px;" class="text-right">
                                    {{ getHargaNetInvoice(item, bpb.bpb_id) | price }}
                                  </td>
                                </tr>
                              </table>
                            </div>
                          </v-col>
                          <v-col cols="12" md="6">
                          </v-col>
                          <v-col cols="12" md="6" class="d-flex justify-end pt-0">
                            <div class="fs-13">
                              <table style="width: 100%;">
                                <tr>
                                  <td class="pa-2 font-weight-bold">
                                    Harga Bruto
                                  </td>
                                  <td style="width: 80px" class="pa-2 text-center">
                                    : 
                                  </td>
                                  <td class="pa-2 text-right">
                                    {{ order_lists[bpb.bpb_id].detail.reduce((acc, item) => acc + getHargaBrutoInvoice(item, bpb.bpb_id), 0) | price }}
                                  </td>
                                </tr>
                                <tr>
                                  <td class="pa-2 font-weight-bold">
                                    Diskon 
                                  </td>
                                  <td style="width: 80px" class="pa-2 text-center">
                                    :
                                  </td>
                                  <td class="pa-2 text-right">
                                      {{ order_lists[bpb.bpb_id].detail.reduce((acc, item) => acc + ((item.detail_discount*1) + getDiskonStrataInvoice(item, bpb.bpb_id)), 0) | price }}
                                  </td>
                                </tr>
                                <tr>
                                  <td class="pa-2 font-weight-bold">
                                    Harga Net
                                  </td>
                                  <td style="width: 80px" class="pa-2 text-center">
                                    :
                                  </td>
                                  <td class="pa-2 text-right">
                                    {{ order_lists[bpb.bpb_id].detail.reduce((acc, item) => acc + getHargaNetInvoice(item, bpb.bpb_id), 0) | price }}
                                  </td>
                                </tr>
                              </table>
                            </div>
                          </v-col>
                        </v-row>
                      </v-card-text>
                    </v-card>
                  </div>
                </div>

                <div v-if="!process.load && Object.keys(detail).length > 0  && detail.bpb && detail.bpb.length > 0 && detail.is_muat === '0'">
                  <div>
                    <v-alert
                      text
                      outlined
                      color="deep-orange"
                      icon="mdi-fire"
                    >
                      Pastikan data yang di <b>Inputkan (Qty Muat dan Qty Rusak)</b> 
                      <span v-if="($route.query.is_ekspedisi == 1 || $route.query.is_ekspedisi == '1')">
                        <b>, Biaya Kirim</b>
                        dan harga di <b>Tabel Invoice</b>
                      </span>
                      sudah benar
                      <br>
                      Berikut Data yang di inputkan:
                      <ul>
                        <li v-for="(bpb, bpbIndex) in detail.bpb" :key="bpbIndex">
                          {{ bpb.bpb_number }} - {{ bpb.orders_number }} - {{ bpb.customer_name }}
                          <div>
                            <ul>
                              <li v-if="($route.query.is_ekspedisi == 1 || $route.query.is_ekspedisi == '1')">
                                <b>Biaya Kirim: {{ getBiayaKirimBpb(bpb.bpb_id) | price }}</b>
                              </li>
                              <li>
                                <b>Detail BPB:</b>
                                <ul>
                                  <li v-for="(item, index) in bpb.detail" :key="index"> 
                                    {{ item.varian_name }} - {{ item.varian_sku }} <br> <b>Muat:{{ item.qty_dus }} {{ (item.qty_in_dus*1) > 1 ? 'Dus' : 'Pcs' }} </b>  <br> <b>Rusak: {{ item.qty_dus_rusak }} {{ (item.qty_in_dus*1) > 1 ? 'Dus' : 'Pcs' }} </b>
                                  </li>
                                </ul>
                              </li>
                            </ul>
                          </div>
                          <!-- <div>
                            <ul>
                              <li v-for="(item, index) in bpb.detail" :key="index">
                                <li>
                                  Muat : {{ item.qty_dus }} {{ (item.qty_in_dus*1) > 1 ? 'Dus' : 'Pcs' }}
                                </li>
                                <li>
                                  Rusak : {{ item.qty_dus_rusak }} {{ (item.qty_in_dus*1) > 1 ? 'Dus' : 'Pcs' }}
                                </li>
                              </li>
                            </ul>
                          </div> -->
                        </li>
                      </ul>
                    </v-alert>
                  </div>
                </div>

                <!-- Navigation Buttons -->
                <div class="form-nav">
                  <!-- <v-btn
                    to="/delivery/proses-muat"
                    :disabled="process.form"
                    depressed
                    class="btn btn-outline"
                    style="min-width: 130px;">
                    <v-icon left size="16">mdi-arrow-left</v-icon>
                    Kembali
                  </v-btn> -->
                  <v-btn
                    to="/delivery/proses-muat"
                    :disabled="process.form"
                    depressed
                    large
                    class="mr-3 elegant-btn-cancel"
                    style="min-width: 130px; height: 44px; border-radius: 10px; text-transform: none; font-weight: 500; letter-spacing: 0.2px; background: #f5f7fa; color: #5C9EAD;">
                    <v-icon left size="16" class="mr-1">mdi-arrow-left</v-icon>
                    Kembali
                  </v-btn>
                  <!-- <v-btn 
                    v-if="detail.is_muat === '0'"
                    :loading="process.form"
                    :disabled="process.form"
                    @click="save()"
                    depressed
                    class="btn btn-success"
                    style="min-width: 150px;">
                    <v-icon left size="16">mdi-content-save</v-icon>
                    Simpan
                  </v-btn> -->
                  <v-btn 
                    @click="save()"
                    v-if="detail.is_muat === '0'"
                    :loading="process.form"
                    :disabled="process.form"
                    depressed
                    large
                    class="elegant-btn-save"
                    style="min-width: 160px; height: 44px; border-radius: 10px; text-transform: none; font-weight: 600; letter-spacing: 0.3px; background: linear-gradient(135deg, #3282B8 0%, #0F4C75 100%); color: white; box-shadow: 0 3px 12px rgba(50, 130, 184, 0.25);">
                    <v-icon left size="18" class="mr-1">mdi-check</v-icon>
                    Simpan Data
                  </v-btn>
                </div>
              </div>
            </div>
          </div>
        </section>
      </v-flex>
    </v-layout>
  </div>
</template>

<script>
  import { TokenService } from "@/service/Storage.Service";
  import { get, post, put, patch, destroy } from "@/service/Axios";
  import moment from "moment"
  import axios from "axios";
  import "moment/locale/id"
  export default {
    data () {
      return {
        approved_by: [],
        approved_reason: '',
        date: (new Date(Date.now() - (new Date()).getTimezoneOffset() * 60000)).toISOString().substr(0, 10),
        menu: false,
        modal: false,
        menu2: false,
        
        zoomed: false,
        zoomedTtd: false,
        imageAspectRatio: 1,
        imageAspectRatioTtd: 1,

        dialog: {
          status: false,
          snackbar: false,
          delete: false,
          fullscreen: false
        },
        status: '',

        detail: {},

        rejected_reason: '',

        form: {
          id: '',
          bpb_arr: []
        },
        category: [],
        branch: [],

        mobilephone: {
          name: '',
          id: ''
        },

        upload: {
          ttd: null,
          image_url: null,
          ekspedisi_driver_photo: null,
          ekspedisi_vehicle_photo: null
        },

        bpb_array_biaya_kirim: [],
        ekspedisi_driver_photo_url: '',
        ekspedisi_vehicle_photo_url: '',
        order_lists: {}, // Menyimpan detail SO per BPB, key: bpb_id
        selected: {
          item: '',
          status: [],
          delete: [],
          row: []
        },

        process: {
          form: false,

          load: false,

          image_url: false,
          export: false,
          delete: false,
          ekspedisi_driver_photo: false,
          ekspedisi_vehicle_photo: false
        },
        
        message: {
          success: '',
          error: '',
          status: ''
        }
      }
    },
    components: {
      uploadfolder: () => import(/* webpackPrefetchCategory: true */ '@/components/upload/folder.vue')
    },
    watch: {
      'upload.ekspedisi_driver_photo': {
        handler: function () {
          if (this.upload.ekspedisi_driver_photo) {
            this.process.ekspedisi_driver_photo = this.upload.ekspedisi_driver_photo.process

            if (!this.process.ekspedisi_driver_photo) {
              this.ekspedisi_driver_photo_url = this.upload.ekspedisi_driver_photo.fileuri
            }
          }
        },
        deep: true
      },
      'upload.ekspedisi_vehicle_photo': {
        handler: function () {
          if (this.upload.ekspedisi_vehicle_photo) {
            this.process.ekspedisi_vehicle_photo = this.upload.ekspedisi_vehicle_photo.process

            if (!this.process.ekspedisi_vehicle_photo) {
              this.ekspedisi_vehicle_photo_url = this.upload.ekspedisi_vehicle_photo.fileuri
            }
          }
        },
        deep: true
      }
    },
    computed: {
      user () {
        return this.$store.state.user
      },
      isSuperAdmin () {
        return this.user && (this.user.category_user_id === 1 || this.user.category_user_id === '1')
      },
      rps () {
        return this.$vuetify.breakpoint.name
      },
      fcm () {
        return this.$store.state.fcm
      },
      isDay () {
        let hours = (new Date()).getHours(),
            day = hours >= 5 && hours <= 8 ? 'pagi' : hours > 8 && hours <= 14 ? 'siang' : hours > 14 && hours <= 18 ? 'sore' : 'malam'
        return day
      },
      set_color () {
        return this.$store.state.color
      },
      set_color_rgb () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.97)`
      },
      set_color_rgb_up () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g+30}, ${b+30}, 0.97)`
      },
      set_color_rgb_down () {
        let [r, g, b] = this.$store.state.color.match(/\w\w/g).map(x => parseInt(x, 16))

        return `rgba(${r}, ${g}, ${b}, 0.25)`
      }
    },
    mounted () {
      this.fetchDetail()
    },
    methods: {
      async fetchDetail () {
        this.process.load = true
        this.order_lists = {} // Reset order_lists
        let params = {
          id: this.$route.params.id
        }
        
        // Hanya tambahkan is_ekspedisi jika ada di query parameter
        if (this.$route.query.is_ekspedisi) {
          params.is_ekspedisi = this.$route.query.is_ekspedisi
        }

        await get('admin/surat_jalan/detail', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            this.form.bpb_arr = []
            this.detail = res.results.data
            this.bpb_array_biaya_kirim = []
            res.results.data.bpb.map((item, index) => {
              this.form.bpb_arr.push({
                bpb_id: item.bpb_id,
                bpb_detail: item.detail
              })

              this.bpb_array_biaya_kirim.push({
                bpb_id: item.bpb_id,
                bpb_biaya_kirim: 0
              })
            })
            

            this.form.bpb_arr.map((item, index) => {
              item.bpb_detail.map((items, indexs) => {
                items.bpb_detail_id = items.bpb_detail_id
                items.varian_name = items.varian_name
                items.varian_sku = items.varian_sku
                items.qty_pcs_diterima = items.qty_pcs_diterima
                items.qty_dus_diterima = items.qty_dus_diterima
                items.qty_lusin_diterima = items.qty_lusin_diterima
                items.qty_pcs_return = items.qty_pcs_return
                items.qty_dus_return = items.qty_dus_return
                items.qty_lusin_return = items.qty_lusin_return
                items.qty_dus_muat = items.qty_dus_muat
                items.qty_dus_rusak = items.qty_dus_rusak
              })
            })
          }
          this.process.load = false
          
          // Fetch detail SO untuk setiap BPB yang memiliki orders_id
          if (res.status === 200 && this.detail.bpb && this.detail.bpb.length > 0) {
            this.detail.bpb.forEach((bpb) => {
              if (bpb.orders_id) {
                this.fetchOrderDetail(bpb.orders_id, bpb.bpb_id)
              }
            })
          }
        })
      },
      async fetchOrderDetail (orders_id, bpb_id) {
        let params = {
          id: orders_id,
          bpb_id: bpb_id || ''
        }

        await get('admin/order/detail', { params })
        .then(response => {
          let res = response.data
            
          if (res.status === 200) {
            // Cari BPB detail untuk mendapatkan qty_dus_muat dan qty_in_dus
            let bpbDetail = null
            if (this.detail.bpb && this.detail.bpb.length > 0) {
              bpbDetail = this.detail.bpb.find(bpb => bpb.bpb_id == bpb_id)
            }
            
            let data_detail = []
            res.results.data.detail.map((item, index) => {
              // Cari item yang sesuai di BPB detail berdasarkan bpb_detail_id atau varian_id
              let bpbDetailItem = null
              if (bpbDetail && bpbDetail.detail) {
                bpbDetailItem = bpbDetail.detail.find(detailItem => 
                  detailItem.bpb_detail_id == item.bpb_detail_id || 
                  detailItem.varian_id == item.varian_id
                )
              }
              
              // Gunakan qty_dus_muat dan qty_in_dus dari BPB detail jika ada
              let qtyDusMuat = bpbDetailItem ? (bpbDetailItem.qty_dus_muat*1) : 0
              let qtyInDus = bpbDetailItem ? (bpbDetailItem.qty_in_dus*1) : (item.detail_total_in_dus*1)
              
              // Perhitungan detail_price_dus_new menggunakan qty_dus_muat dengan logika qty_in_dus
              // Jika qty_in_dus > 1, berarti dalam Dus: harga per dus = detail_price_per_pcs * qty_in_dus, total = harga per dus * qty_dus_muat
              // Jika qty_in_dus <= 1, berarti dalam Pcs: harga per pcs = detail_price_per_pcs, total = harga per pcs * qty_dus_muat
              let detailPriceDusNew = 0
              if (qtyInDus > 1) {
                // Dalam satuan Dus
                detailPriceDusNew = Math.round(item.detail_price_per_pcs * qtyInDus) * qtyDusMuat
              } else {
                // Dalam satuan Pcs
                detailPriceDusNew = item.detail_price_per_pcs * qtyDusMuat
              }
              
              data_detail.push(
                {
                  ...item,
                  detail_price_dus_new: detailPriceDusNew,
                  qty_dus_muat: qtyDusMuat,
                  qty_in_dus: qtyInDus
                }
              )
            })
            let order_list = res.results.data
            order_list.detail = data_detail
            
            // Simpan order_list per BPB
            this.$set(this.order_lists, bpb_id, order_list)
          }
        })
      },
      reset (index) {
        if (this.$refs.form) this.$refs.form.reset()
        
        this.rejected_reason = ''

        this.process.form = false

        this.message.error = ''
      },
      onImageLoad(e) {
        const img = e.target
        this.imageAspectRatio = img.naturalWidth / img.naturalHeight
      },
      onImageLoadAkta(e) {
        const img = e.target
        this.imageAspectRatioAkta = img.naturalWidth / img.naturalHeight
      },
      getStatusText(status) {
        switch (status) {
          case 'pengiriman': return 'Pengiriman';
          case 'diterima': return 'Diterima Customer';
          case 'Set Order': return 'Menunggu Pengiriman';
          case 'pengiriman terkonfirmasi': return 'Pengiriman Terkonfirmasi';
          default: return '-';
        }
      },
      getStatusColor(status) {
        switch (status) {
          case 'pengiriman': return '#F07B3F'; // Orange
          case 'diterima': return '#00ADB5'; // Teal
          case 'Set Order': return '#FFD460'; // Yellow
          case 'pengiriman terkonfirmasi': return '#00ADB5'; // Teal
          default: return '#9ca3af'; // Grey
        }
      },
      // Helper method untuk mendapatkan qty_dus_muat dari form berdasarkan bpb_id dan bpb_detail_id atau varian_id
      getQtyDusMuatFromForm(bpb_id, bpb_detail_id, varian_id) {
        try {
          if (!this.detail || !this.detail.bpb || !this.detail.bpb.length) return 0
          
          let bpb = this.detail.bpb.find(b => b.bpb_id == bpb_id)
          if (!bpb || !bpb.detail || !bpb.detail.length) return 0
          
          // Cari berdasarkan bpb_detail_id terlebih dahulu (jika ada)
          let detailItem = null
          if (bpb_detail_id !== undefined && bpb_detail_id !== null) {
            detailItem = bpb.detail.find(d => d.bpb_detail_id && d.bpb_detail_id.toString() === String(bpb_detail_id))
          }
          
          // Jika tidak ditemukan, cari berdasarkan varian_id
          if (!detailItem && varian_id !== undefined && varian_id !== null) {
            detailItem = bpb.detail.find(d => d.varian_id && d.varian_id.toString() === String(varian_id))
          }
          
          if (detailItem && detailItem.qty_dus_muat !== undefined && detailItem.qty_dus_muat !== null) {
            return detailItem.qty_dus_muat*1
          }
          
          return 0
        } catch (e) {
          console.error('getQtyDusMuatFromForm error:', e, { bpb_id, bpb_detail_id, varian_id })
          return 0
        }
      },
      // Helper method untuk mendapatkan qty_in_dus dari form berdasarkan bpb_id dan bpb_detail_id atau varian_id
      getQtyInDusFromForm(bpb_id, bpb_detail_id, varian_id) {
        try {
          if (!this.detail || !this.detail.bpb || !this.detail.bpb.length) return 0
          
          let bpb = this.detail.bpb.find(b => b.bpb_id == bpb_id)
          if (!bpb || !bpb.detail || !bpb.detail.length) return 0
          
          // Cari berdasarkan bpb_detail_id terlebih dahulu (jika ada)
          let detailItem = null
          if (bpb_detail_id !== undefined && bpb_detail_id !== null) {
            detailItem = bpb.detail.find(d => d.bpb_detail_id && d.bpb_detail_id.toString() === String(bpb_detail_id))
          }
          
          // Jika tidak ditemukan, cari berdasarkan varian_id
          if (!detailItem && varian_id !== undefined && varian_id !== null) {
            detailItem = bpb.detail.find(d => d.varian_id && d.varian_id.toString() === String(varian_id))
          }
          
          if (detailItem && detailItem.qty_in_dus !== undefined && detailItem.qty_in_dus !== null) {
            return detailItem.qty_in_dus*1
          }
          
          return 0
        } catch (e) {
          console.error('getQtyInDusFromForm error:', e, { bpb_id, bpb_detail_id, varian_id })
          return 0
        }
      },
      // Method untuk menghitung detail_price_dus_new secara real-time
      calculateDetailPriceDusNew(item, bpb_id) {
        try {
          if (!item) return 0
          let varian_id = item.varian_id || item.detail_varian_id
          let qtyDusMuat = this.getQtyDusMuatFromForm(bpb_id, item.bpb_detail_id, varian_id)
          let qtyInDus = this.getQtyInDusFromForm(bpb_id, item.bpb_detail_id, varian_id)
          
          // Jika tidak ada di form, gunakan nilai dari order_lists
          if (qtyDusMuat === 0 && item.qty_dus_muat) {
            qtyDusMuat = item.qty_dus_muat*1
          }
          if (qtyInDus === 0 && item.qty_in_dus) {
            qtyInDus = item.qty_in_dus*1
          }
          
          // Perhitungan detail_price_dus_new menggunakan qty_dus_muat dengan logika qty_in_dus
          if (qtyInDus > 1) {
            // Dalam satuan Dus
            return Math.round((item.detail_price_per_pcs || 0) * qtyInDus) * qtyDusMuat
          } else {
            // Dalam satuan Pcs
            return (item.detail_price_per_pcs || 0) * qtyDusMuat
          }
        } catch (e) {
          return 0
        }
      },
      // Method untuk menghitung harga bruto di tabel invoice
      getHargaBrutoInvoice(item, bpb_id) {
        try {
          if (!item) return 0
          let varian_id = item.varian_id || item.detail_varian_id
          let qtyDusMuat = this.getQtyDusMuatFromForm(bpb_id, item.bpb_detail_id, varian_id) || (item.qty_dus_muat*1) || 0
          let detailPriceDusNew = this.calculateDetailPriceDusNew(item, bpb_id)
          return (qtyDusMuat === 0 ? 0 : detailPriceDusNew) + (item.detail_price_lusin*1 || 0) + (item.detail_price_pcs*1 || 0)
        } catch (e) {
          return 0
        }
      },
      // Method untuk menghitung diskon strata di tabel invoice
      getDiskonStrataInvoice(item, bpb_id) {
        try {
          if (!item) return 0
          let varian_id = item.varian_id || item.detail_varian_id
          let qtyDusMuat = this.getQtyDusMuatFromForm(bpb_id, item.bpb_detail_id, varian_id) || (item.qty_dus_muat*1) || 0
          return (item.detail_strata_nominal*1 || 0) * qtyDusMuat
        } catch (e) {
          return 0
        }
      },
      // Method untuk menghitung harga net di tabel invoice
      getHargaNetInvoice(item, bpb_id) {
        try {
          if (!item) return 0
          let varian_id = item.varian_id || item.detail_varian_id
          let qtyDusMuat = this.getQtyDusMuatFromForm(bpb_id, item.bpb_detail_id, varian_id) || (item.qty_dus_muat*1) || 0
          let detailPriceDusNew = this.calculateDetailPriceDusNew(item, bpb_id)
          let hargaBruto = (qtyDusMuat === 0 ? 0 : detailPriceDusNew) + (item.detail_price_lusin*1 || 0) + (item.detail_price_pcs*1 || 0)
          let diskon = ((item.detail_discount*1 || 0)) + this.getDiskonStrataInvoice(item, bpb_id)
          return hargaBruto - diskon
        } catch (e) {
          return 0
        }
      },
      // Method untuk mendapatkan quantity string di tabel invoice
      getQuantityStringInvoice(item, bpb_id) {
        try {
          if (!item) return '0.0.0'
          let varian_id = item.varian_id || item.detail_varian_id
          let qtyDusMuat = this.getQtyDusMuatFromForm(bpb_id, item.bpb_detail_id, varian_id) || 0
          let qtyInDus = this.getQtyInDusFromForm(bpb_id, item.bpb_detail_id, varian_id) || (item.detail_total_in_dus*1) || 0
          let qtyDus = (qtyInDus > 1) ? qtyDusMuat : 0
          let qtyPcs = (qtyInDus <= 1) ? qtyDusMuat : 0
          return `${qtyDus}.${item.bpb_detail_qty_lusin_diterima*1 || 0}.${qtyPcs}`
        } catch (e) {
          return '0.0.0'
        }
      },

      getSubTotalPerBpb(bpb_id) {
        let subTotal = 0
        for (const item of this.order_lists[bpb_id].detail) {
          subTotal += this.getHargaBrutoInvoice(item, bpb_id)
        }
        console.log(subTotal)
        return subTotal
      },

      getTotalPerBpb(bpb_id) {
        let total = 0
        for (const item of this.order_lists[bpb_id].detail) {
          total += this.getHargaNetInvoice(item, bpb_id)
        }
        console.log(total)
        return total
      },

      getDueDateBpb(bpb_id) {
        var someDate = new Date();
            someDate.setDate(someDate.getDate() + (this.order_lists[bpb_id].customer_term*1)); //number  of days to add, e.x. 15 days
            var dateFormated = someDate.toISOString().substr(0,10);
        console.log(this.order_lists[bpb_id].customer_term*1)
        return dateFormated
      },

      getBiayaKirimBpb(bpb_id) {
        return this.bpb_array_biaya_kirim.find(item => item.bpb_id == bpb_id)?.bpb_biaya_kirim || 0
      },
      async save () {
        this.message.error = ''
        const isValid = await this.$refs.form.validate()
        let is_ekspedisi = this.detail.is_ekspedisi || (this.$route.query.is_ekspedisi == 1 || this.$route.query.is_ekspedisi == '1' ? 1 : 0)
        
        // Validasi foto ekspedisi jika is_ekspedisi = 1
        if ((is_ekspedisi == 1 || is_ekspedisi == '1') && this.detail.is_muat === '0') {
          if (!this.ekspedisi_driver_photo_url || this.ekspedisi_driver_photo_url === '') {
            this.message.error = 'Foto Driver Ekspedisi wajib diisi'
            // Scroll ke upload foto driver
            setTimeout(() => {
              const uploadDriver = document.querySelector('.upload-hover, [slot="activator"]')
              if (uploadDriver) {
                uploadDriver.scrollIntoView({ behavior: 'smooth', block: 'center' })
              }
            }, 100)
            return
          }
          if (!this.ekspedisi_vehicle_photo_url || this.ekspedisi_vehicle_photo_url === '') {
            this.message.error = 'Foto Kendaraan Ekspedisi wajib diisi'
            // Scroll ke upload foto kendaraan
            setTimeout(() => {
              const uploadVehicle = document.querySelectorAll('.upload-hover, [slot="activator"]')[1]
              if (uploadVehicle) {
                uploadVehicle.scrollIntoView({ behavior: 'smooth', block: 'center' })
              }
            }, 100)
            return
          }
        }
        
        if (isValid) {
        // Susun bpb_array sesuai format yang diminta backend
        // Contoh yang diminta:
        // [{ "bpb_customer_id": 2428, "bpb_id": 2910, "bpb_orders_id": 2100, "bpb_sub_total": 3500000, "bpb_biaya_kirim": 20000, "bpb_total": 3520000, "bpb_due_date": "2025-12-28" }]
        let bpb_array = []
        this.detail.bpb.map((item) => {
          bpb_array.push({
            // Gunakan fallback ke field lain kalau nama field di API berbeda
            bpb_customer_id: item.bpb_customer_id || item.customer_id || item.customer_id_fk || null,
            bpb_id: item.bpb_id, // ini sudah pasti ada
            bpb_orders_id: item.bpb_orders_id || item.orders_id || item.order_id || null,
            bpb_sub_total: this.getSubTotalPerBpb(item.bpb_id) || null,
            bpb_biaya_kirim: this.getBiayaKirimBpb(item.bpb_id) || 0,
            bpb_total: this.getTotalPerBpb(item.bpb_id) || null,
            bpb_due_date: this.getDueDateBpb(item.bpb_id)
          })
        })
        
        let detail_array = []
        let hasEmptyQty = false
        this.detail.bpb.map((item, index) => {
          item.detail.map((items, indexs) => {
            // Validasi qty_dus_muat dan qty_dus_rusak
            if (items.qty_dus_muat === null || items.qty_dus_muat === undefined || items.qty_dus_muat === '') {
              hasEmptyQty = true
            }
            if (items.qty_dus_rusak === null || items.qty_dus_rusak === undefined || items.qty_dus_rusak === '') {
              hasEmptyQty = true
            }
            
            detail_array.push({
              bpb_detail_id: items.bpb_detail_id,
              qty_dus_muat: items.qty_dus_muat || 0,
              qty_dus_rusak: items.qty_dus_rusak || 0
            })
          })
        })
        
        // Validasi qty
        if (hasEmptyQty) {
          this.message.error = 'Mohon lengkapi Qty Dus Muat dan Qty Dus Rusak untuk semua item'
          setTimeout(() => {
            const firstQtyField = document.querySelector('input[type="text"]')
            if (firstQtyField) {
              firstQtyField.scrollIntoView({ behavior: 'smooth', block: 'center' })
            }
          }, 100)
          return
        }
        
        this.process.form = true
        
        let form = {
          id: this.detail.id,
          is_ekspedisi: is_ekspedisi,
          detail_array: detail_array,
          bpb_array: bpb_array,
          orders_number: this.detail.bpb[0].orders_number
        }
        
        // Hanya tambahkan field ekspedisi jika is_ekspedisi = 1
        if (is_ekspedisi == 1 || is_ekspedisi == '1') {
          form.ekspedisi_driver_photo_url = this.ekspedisi_driver_photo_url || ''
          form.ekspedisi_vehicle_photo_url = this.ekspedisi_vehicle_photo_url || ''
        }

        let url = 'admin/surat_jalan/add_proses_muat'

        // console.log(form)

        await post(url, {
          data: form
        }).then(response => {
          let res = response.data

          this.process.form = false

          if (res.status === 200) {

            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetchDetail()
          } else {
            this.message.error = res.message
          }
        })
          
        } else {
          // Tampilkan error jika form tidak valid
          const errors = Object.entries(this.$refs.form.errors)
            .map(([key, value]) => ({ key, value }))
            .filter(error => error['value'].length)
          
          if (errors.length > 0) {
            this.message.error = 'Mohon lengkapi semua field yang wajib diisi'
            // AUTO FOCUS ON TEXT-FIELD
            setTimeout(() => {
              if (this.$refs.form && this.$refs.form.refs && this.$refs.form.refs[errors[0]['key']]) {
                this.$refs.form.refs[errors[0]['key']].$el.scrollIntoView({
                  behavior: 'smooth',
                  block: 'center'
                })
              }
            }, 10)
          } else {
            this.message.error = 'Mohon lengkapi semua field yang wajib diisi'
          }
        }

        
      },
      async exports (id) {
        this.message.error = ''

        this.process.export = true

        let params = {
          bpb_id: id
        }

        await axios({
          url: `${process.env.VUE_APP_API_URL}admin/bpb/export_pdf`,
          method: 'GET',
          responseType: 'blob', // important,
          params: params,
          headers: {
            Authorization: process.env.VUE_APP_XAUTH,
            token: TokenService.getToken()
          }
        }).then((response) => {
          let res = response

          this.process.export = false
          console.log(res.headers)
          let disposition = res.headers['content-disposition']
          // console.log(disposition)
          var fileName = res.headers['content-disposition'].split('filename=\"')[1]
          let filename = ''

          if (disposition && disposition.indexOf('inline') !== -1) {
            var filenameRegex = /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/;
            var matches = filenameRegex.exec(disposition);
            if (matches != null && matches[1]) { 
              filename = matches[1].replace(/['"]/g, '');
            }
          }
          // console.log(filename)

          if (res.status === 200) {
            this.dialog.snackbar = true
            this.message.success = 'Berhasil mengeksport pdf'

            const url = window.URL.createObjectURL(new Blob([response.data]))
            const link = document.createElement('a')
            link.href = url

            link.setAttribute('download', filename)
            document.body.appendChild(link)

            link.click()
          } else {
            this.message.error = res.message
          }
        })
      },

      toDelete (id) {
        this.selected.delete = [id]

        this.dialog.delete = true
      },
      async deletes () {
        this.message.error = ''

        this.process.delete = true

        await post(`admin/bpb/lepas_surat_jalan`, {
          data: {
            id: this.selected.delete[0]
          }
        }).then(response => {
          let res = response.data

          this.process.delete = false

          if (res.status === 200) {

            this.dialog.delete = false

            this.selected.row = []
            this.selected.delete = []
            
            this.dialog.snackbar = true
            this.message.success = res.message

            this.dialog.fullscreen = false

            this.fetchDetail()
          } else {
            this.message.error = res.message
          }
        })
      }
    }
  }
</script>


<style>
  /* ::-webkit-scrollbar {
    width: 10px;
    height: 10px;
    background-color: #F5F5F5;
  }
  ::-webkit-scrollbar-track{
    background-color: #F5F5F5;
    border-radius: 10px;
  } */
  ::-webkit-scrollbar-thumb{
    border-radius: 10px;
    background-color: #718EBF;
  }
  table, th, td {
    /* border: 1px solid #ededed;
    border-collapse: collapse; */
    /* border: thin ridge black; */
    border-spacing: 4px;
    border-collapse: collapse;
  }

  .view {
    margin: auto;
    /* width: 100%; */
  }

  .wrapper { 
    overflow-y: auto; 
    height: calc(100vh - 390px); 
  } 

  .wrapper th { 
    position: sticky; 
    top: 0; 
    background-color: white !important;
  } 
  .sticky-col {
    position: -webkit-sticky;
    position: sticky;
    background-color: white !important;
  }

  .one-col {
    width: 60px;
    min-width: 60px;
    max-width: 60px;
    left: 0px;
  }

  .second-col {
    width: 150px;
    min-width: 150px;
    max-width: 150px;
    left: 150px;
  }

  .three-col {
    width: 150px;
    min-width: 150px;
    max-width: 150px;
    left: 300px;
  }

  .four-col {
    width: 200px;
    min-width: 200px;
    max-width: 200px;
    left: 450px;
  }

  tr:hover {background-color: #1976d236;}
  tr.selected {background-color: #1976d236;}

/* Elegant Container */
.elegant-container {
  background: linear-gradient(to bottom, #f5f7fa 0%, #ffffff 100%);
  min-height: 100vh;
}

/* Customer Page */
.customer-page {
  position: relative;
  padding: 18px;
  padding-top: 36px;
  min-height: 100%;
}

/* Animated Background */
.animated-bg {
  position: fixed;
  top: 0;
  left: 0;
  right: 0;
  bottom: 0;
  pointer-events: none;
  overflow: hidden;
  z-index: 0;
}

.bg-shape {
  position: absolute;
  border-radius: 50%;
  opacity: 0.6;
  animation: float 20s ease-in-out infinite;
}

.shape-1 {
  width: 300px;
  height: 300px;
  background: linear-gradient(135deg, #00ADB5 0%, #00ADB5 100%);
  top: -100px;
  right: -50px;
  filter: blur(60px);
  animation-delay: 0s;
}

.shape-2 {
  width: 200px;
  height: 200px;
  background: linear-gradient(135deg, #FFD460 0%, #F07B3F 100%);
  bottom: 100px;
  left: -50px;
  filter: blur(50px);
  animation-delay: -5s;
}

.shape-3 {
  width: 150px;
  height: 150px;
  background: linear-gradient(135deg, #EA5455 0%, #EA5455 100%);
  top: 50%;
  right: 20%;
  filter: blur(40px);
  animation-delay: -10s;
}

@keyframes float {
  0%, 100% { transform: translateY(0) rotate(0deg); }
  25% { transform: translateY(-20px) rotate(5deg); }
  50% { transform: translateY(0) rotate(0deg); }
  75% { transform: translateY(20px) rotate(-5deg); }
}

/* Page Header */
.page-header {
  position: relative;
  z-index: 1;
  display: flex;
  align-items: flex-start;
  gap: 16px;
  margin-bottom: 28px;
}

.header-content h1 {
  font-size: 18px;
  font-weight: 700;
  color: #222831;
  margin: 0 0 4px;
  letter-spacing: -0.5px;
}

.header-content p {
  font-size: 14px;
  color: #393E46;
  margin: 0;
}

.header-badge {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  padding: 6px 12px;
  border-radius: 8px;
  font-size: 12px;
  font-weight: 600;
  color: white;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.15);
}

/* Main Card */
.main-card {
  position: relative;
  z-index: 1;
  background: white;
  border-radius: 12px;
  box-shadow: 0 4px 30px rgba(34, 40, 49, 0.08);
  border: 1px solid rgba(238, 238, 238, 0.6);
  overflow: hidden;
}

/* Loading Container */
.loading-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  justify-content: center;
  padding: 80px 24px;
  min-height: 400px;
}

/* Form Step */
.form-step {
  padding: 24px;
}

.form-step:last-child {
  border-bottom: none;
}

.step-header {
  display: flex;
  align-items: center;
  gap: 16px;
  margin-bottom: 16px;
  padding-bottom: 24px;
  border-bottom: 2px solid #f8f9fa;
}

.step-icon {
  width: 42px;
  height: 42px;
  border-radius: 6px;
  display: flex;
  align-items: center;
  justify-content: center;
}

.step-icon.teal {
  background: linear-gradient(135deg, #00ADB5 0%, #00ADB5 100%);
  box-shadow: 0 8px 20px rgba(0, 173, 181, 0.3);
}

.step-icon.orange {
  background: linear-gradient(135deg, #F07B3F 0%, #F07B3F 100%);
  box-shadow: 0 8px 20px rgba(240, 123, 63, 0.3);
}

.step-icon.coral {
  background: linear-gradient(135deg, #EA5455 0%, #EA5455 100%);
  box-shadow: 0 8px 20px rgba(234, 84, 85, 0.3);
}

.step-icon.purple {
  background: linear-gradient(135deg, #9C27B0 0%, #7B1FA2 100%);
  box-shadow: 0 8px 20px rgba(156, 39, 176, 0.3);
}

.step-header h2 {
  font-size: 14px;
  font-weight: 700;
  color: #222831;
  margin: 0 0 4px;
}

.step-header p {
  font-size: 12px;
  color: #393E46;
  margin: 0;
}

/* Info Grid */
.info-grid {
  display: grid;
  grid-template-columns: repeat(3, 1fr);
  gap: 20px;
}

.info-card.full-width {
  grid-column: span 3;
}

.info-card {
  background: #f8f9fa;
  border-radius: 8px;
  padding: 16px;
  border: 1px solid #e8eaed;
  transition: all 0.3s ease;
}

.info-card:hover {
  background: #ffffff;
  box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  transform: translateY(-2px);
}

.info-label {
  display: flex;
  align-items: center;
  font-size: 12px;
  font-weight: 600;
  color: #6b7280;
  margin-bottom: 8px;
  text-transform: uppercase;
  letter-spacing: 0.5px;
}

.info-value {
  font-size: 15px;
  font-weight: 600;
  color: #222831;
  word-break: break-word;
}

/* Responsive */
@media (max-width: 960px) {
  .info-grid {
    grid-template-columns: 1fr;
  }
  
  .info-card.full-width {
    grid-column: span 1;
  }

  .page-header {
    flex-direction: column;
    align-items: flex-start;
  }
}

@media (max-width: 600px) {
  .customer-page {
    padding: 16px;
  }
  
  .header-content h1 {
    font-size: 22px;
  }
  
  .form-step {
    padding: 18px;
  }
  
  .bg-shape {
    opacity: 0.3;
  }
}

/* Form Navigation */
.form-nav {
  display: flex;
  align-items: center;
  /* padding: 0px 32px; */
  padding-bottom: 24px !important;
  background: transparent;
  justify-content: flex-end;
  gap: 12px;
}

.btn {
  display: inline-flex;
  align-items: center;
  gap: 8px;
  padding: 12px 24px;
  border: none;
  border-radius: 12px;
  font-size: 14px;
  font-weight: 600;
  cursor: pointer;
  transition: all 0.2s ease;
  height: 44px;
}

.btn-outline {
  background: white;
  color: #222831;
  border: 1px solid #EEEEEE;
}

.btn-outline:hover {
  background: #f8f9fa;
  border-color: #00ADB5;
  color: #00ADB5;
}

.btn-success {
  background: linear-gradient(135deg, #00ADB5 0%, #00ADB5 100%);
  color: white;
  box-shadow: 0 4px 15px rgba(0, 173, 181, 0.3);
}

.btn-success:hover:not(:disabled) {
  transform: translateY(-2px);
  box-shadow: 0 6px 20px rgba(0, 173, 181, 0.4);
}

.btn-success:disabled {
  opacity: 0.7;
  cursor: not-allowed;
}

/* Ekspedisi Info Box */
.ekspedisi-info-box {
  display: flex;
  align-items: center;
  padding: 12px 16px;
  background: white;
  border-radius: 6px;
  border: 1px solid #e8eaed;
  min-height: 44px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.04);
  transition: all 0.3s ease;
}

.ekspedisi-info-box:hover {
  border-color: #d0d5dd;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.06);
}

.ekspedisi-info-value {
  font-size: 14px;
  font-weight: 500;
  color: #222831;
  flex: 1;
}

/* Upload Hover */
.upload-hover:hover {
  border-color: #00ADB5 !important;
  background: rgba(0, 173, 181, 0.04) !important;
  box-shadow: 0 0 0 3px rgba(0, 173, 181, 0.08) !important;
}

/* Error Toast */
.error-toast {
  position: fixed;
  top: 24px;
  left: 50%;
  transform: translateX(-50%);
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 14px 20px;
  background: #EA5455;
  border-radius: 12px;
  box-shadow: 0 4px 20px rgba(234, 84, 85, 0.3);
  z-index: 1000;
}

.error-toast span {
  color: white;
  font-size: 14px;
  font-weight: 500;
}

.error-toast button {
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  border: none;
  border-radius: 50%;
  background: rgba(255, 255, 255, 0.2);
  cursor: pointer;
  transition: background 0.2s ease;
}

.error-toast button:hover {
  background: rgba(255, 255, 255, 0.3);
}
</style>